import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "line",
  "use": "line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"line\"><path style=\"fill:none;stroke:currentColor;stroke-width:.7;stroke-linejoin:round;stroke-dasharray:2.44,.61;stroke-dashoffset:6.00390005\" d=\"m12.38 1033.8-8.775-.661 2.12 7.858\" transform=\"matrix(1.9204 0 0 2.01316 -3.252 -2075.456)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol